import { ChangeEventHandler } from "react";
import DateRangePicker from "../../../components/global-components/litePicker";

interface Props {
  index: number;
  carrierName: string;
  fuelTypeName: string;
  tenThoughUnder: string | number;
  tenThoughToFiftyFiveThough: string | number;
  fiftyFiveThoughGreater: string | number;
  selectedDates: {
    startDate: Date,
    endDate: Date
  };
  areEditing: boolean;
  canEditAdminFuelSurcharge: boolean;
  onChangeTenThoughUnder: ChangeEventHandler;
  onChangeTenThoughToFiftyFiveThough: ChangeEventHandler;
  onChangeFiftyThoughGreater: ChangeEventHandler;
  onChangeSelectedDates: (startDate: Date, endDate: Date) => void;
  onClickUpdate: any;
}

export default function TableRow({
  index,
  carrierName,
  fuelTypeName,
  tenThoughUnder,
  tenThoughToFiftyFiveThough,
  fiftyFiveThoughGreater,
  selectedDates,
  areEditing,
  canEditAdminFuelSurcharge,
  onChangeTenThoughUnder,
  onChangeTenThoughToFiftyFiveThough,
  onChangeFiftyThoughGreater,
  onChangeSelectedDates,
  onClickUpdate,
}: Props) {
  return (
    <tr>
      <td className='align-middle'>{carrierName}</td>
      <td className='align-middle'>{fuelTypeName}</td>
      <td className='align-middle'>
        <div className='d-flex justify-content-between  rounded-2 align-items-center '>
          <input
            className={`form-control mr-sm-2 ${
              tenThoughUnder ? 'highlighted-border' : ''
            }`}
            defaultValue={tenThoughUnder}
            onChange={onChangeTenThoughUnder}
          />
        </div>
      </td>
      <td className='align-middle'>
        <div className='d-flex justify-content-between  rounded-2 align-items-center '>
          <input
            className={`form-control mr-sm-2 ${
              tenThoughToFiftyFiveThough
                ? 'highlighted-border'
                : ''
            }`}
            defaultValue={tenThoughToFiftyFiveThough}
            onChange={onChangeTenThoughToFiftyFiveThough}
          />
        </div>
      </td>
      <td className='align-middle'>
        <div className='d-flex justify-content-between   rounded-2 align-items-center '>
          <input
            className={`form-control mr-sm-2 ${
              fiftyFiveThoughGreater
                ? 'highlighted-border'
                : ''
            }`}
            defaultValue={fiftyFiveThoughGreater}
            onChange={onChangeFiftyThoughGreater}
          />
        </div>
      </td>
      <td className='align-middle'>
        <DateRangePicker
          id={`date_range_picker_${index}`}
          className={`form-control ubbe-input px-2 py-2 pe-5  h-50   ${'highlighted-border'}`}
          selectedDates={selectedDates}
          onChange={onChangeSelectedDates}
        />
      </td>
      {canEditAdminFuelSurcharge && (
        <td className='align-middle'>
          <button
            className={
              areEditing
                ? 'active-filter px-2 py-2 h-auto '
                : 'mt-auto px-2 py-2 h-auto disable-filter'
            }
            onClick={onClickUpdate}
          >
            Update
          </button>
        </td>
      )}
    </tr>
  );
}
